import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import FieldDisplay from '../../../../../molecules/FieldDisplay'
import { usePolicy } from '../../../../../../hooks/usePolicy'

function DataSourceAttributes ({ datasource }) {
  const isInternalUser = usePolicy('admin_denali_internal')

  const fields = useMemo(() => {
    const baseFields = [
      { label: 'ID', value: datasource.catalogDatasourceId },
      { label: 'Namespace', value: `${datasource.namespace.code} (${datasource.namespaceId})` },
      { label: 'Schema', value: `${datasource.schema.code} (${datasource.schemaId})` },
      { label: 'Name', value: datasource.displayName },
      { label: 'Code', value: datasource.code },
      { label: 'Type', value: datasource.type },
      { label: 'Sub-Type', value: datasource.subType }
    ]

    const internalFields = isInternalUser ? [
      { label: 'is System', value: datasource.isSystem ?? false, format: 'bool' },
      { label: 'is Internal', value: datasource.isInternal ?? false, format: 'bool' }
    ] : []

    const otherFields = [
      { label: 'is AI Enabled', value: datasource.isAiEnabled ?? false, format: 'bool' },
      { label: 'is Always Available', value: datasource.isAlwaysAvailable ?? false, format: 'bool' },
      { label: 'is Deprecated', value: datasource.isDeprecated ?? false, format: 'bool' }
    ]

    return [...baseFields, ...internalFields, ...otherFields]
  }, [datasource, isInternalUser])

  return (
    <FieldDisplay fields={fields} />
  )
}

DataSourceAttributes.propTypes = {
  datasource: PropTypes.shape({
    catalogDatasourceId: PropTypes.number,
    namespaceId: PropTypes.number,
    schemaId: PropTypes.number,
    displayName: PropTypes.string,
    code: PropTypes.string,
    type: PropTypes.string,
    subType: PropTypes.string,
    data: PropTypes.object,
    isSystem: PropTypes.bool,
    isInternal: PropTypes.bool,
    isAiEnabled: PropTypes.bool,
    isAlwaysAvailable: PropTypes.bool,
    isDeprecated: PropTypes.bool,
    description: PropTypes.string,
    namespace: PropTypes.shape({
      displayName: PropTypes.string,
      code: PropTypes.string
    }),
    schema: PropTypes.shape({
      displayName: PropTypes.string,
      code: PropTypes.string
    })
  })
}

export default DataSourceAttributes
